exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{width:95%;margin-top:50px}.vue-title,.VuePagination{text-align:center}.vue-title{margin-bottom:10px}.vue-pagination-ad{text-align:center}.glyphicon.glyphicon-eye-open{width:16px;display:block;margin:0 auto}th:nth-child(3){text-align:center}.VueTables__child-row-toggler{width:16px;height:16px;line-height:16px;display:block;margin:auto;text-align:center}.VueTables__child-row-toggler--closed:before{content:\"+\"}.VueTables__child-row-toggler--open:before{content:\"-\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d6a0b72","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DataTable.vue
// module id = 219
// module chunks = 0